import { CommonModule } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MultiOrgFilterComponent } from '../multi-org-filter/multi-org-filter.component';
import { RoleRequestService } from 'src/app/modules/user-profile/services/role-request.service';
import { debounceTime, Subject, takeUntil, zip } from 'rxjs';
import { ApplicationService } from 'eas-core-lib';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MultiOrgFilter } from 'src/app/modules/user-profile/models/role-request.models';

@Component({
  selector: 'app-role-request-home',
  imports: [CommonModule, RouterModule, MultiOrgFilterComponent, NgxSpinnerModule],
  templateUrl: './role-request-home.component.html',
  styleUrl: './role-request-home.component.css'
})
export class RoleRequestHomeComponent implements OnInit, OnDestroy {
  private roleRequestService = inject(RoleRequestService);
  private appService = inject(ApplicationService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  isOrgSelected: boolean = false;
  manageRequest = 1623410000;
  addRemoveRole = 1623420000;

  showMangeRequest = false;
  showAddRemoveRole = false;
  hasNoOrgs = false;
  unsubscribe$ = new Subject();
  loading = false;

  ngOnInit() {
    let isInitial = true;
    this.roleRequestService.multiOrgFilters$.pipe(takeUntil(this.unsubscribe$), debounceTime(200)).subscribe((org: MultiOrgFilter) => {
      if (isInitial) {
        isInitial = false;
        return;
      }
      if (org.selectedOrganization && org.isHomeFilter) {
        this.selectedOrgChange(org.selectedOrganization);
      }
      this.hasNoOrgs = org.hasNoOrgs;
    });
  }

  regenerateClaimsToken(org: any) {
    this.showAddRemoveRole = false;
    this.showMangeRequest = false;
    this.loading = true;

    this.appService.generateClaimsToken({
      organizationId: org.orgKey,
      audienceId: this.appService.user.organizations[0]?.audiences[0]?.aud_id,
      applicationId: this.appService.user.organizations[0]?.audiences[0]?.applications[0]?.app_id
    }
    ).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (res: any) => {
        zip(this.roleRequestService.hasAuthorizationForComponent(this.manageRequest),
          this.roleRequestService.hasAuthorizationForComponent(this.addRemoveRole)).pipe(takeUntil(this.unsubscribe$))
          .subscribe((res: any) => {
            this.showMangeRequest = res[0];
            this.showAddRemoveRole = res[1];
            this.loading = false;
          });
      }
    );
  }

  selectedOrgChange(org: any) {
    this.isOrgSelected = org ? true : false;
    this.regenerateClaimsToken(org);
  }

  ngOnDestroy() {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  routeTo(route: string) {
    this.router.navigate([route], { relativeTo: this.route });
  }
}
